export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('form_label_encoding_export') || '赋码导出',
    icon: 'el-icon-bottom',
    menuType: 'nc-export',
    allow: 'N',
    divided: true,
    data: {
      templateGroup: 'plan-setNc',
      exportCheckUrl: '/factory/notice/order/export/nc/check',
      params: { userInfo: that.info },
    },
    disabled: ({ noticeOrderStatus }) => noticeOrderStatus !== 'N',
  },
  {
    text: that.$l('menu_text_nc') || 'NC赋码',
    icon: 'el-icon-c-scale-to-original',
    menuType: 'nc',
    allow: 'B',
  },
  {
    text: that.$l('menu_text_assignment') || '指派跟单',
    icon: 'el-icon-s-custom',
    menuType: 'assignment',
    allow: 'A',
  },
  {
    text: that.$l('menu_text_updateFactory') || '更新工厂订单编号',
    icon: 'el-icon-edit-outline',
    menuType: 'updateFactory',
    allow: 'D',
  },
  {
    text: that.$l('menu_text_export') || '订单导出',
    icon: 'el-icon-download',
    menuType: 'order-export',
    allow: 'E',
    divided: true,
    data: {
      templateGroup: 'plan-noticeOrder',
      exportCheckUrl: '/factory/notice/order/export/order/check',
      params: { userInfo: that.info },
    },
    disabled: ({ noticeOrderStatus }) => noticeOrderStatus !== 'Y',
  },
  {
    text: that.$l('menu_text_money') || '成本测算',
    icon: 'el-icon-money',
    menuType: 'cost',
    allow: 'F',
    disabled: ({ noticeOrderStatus, noticeCostStatus }) => {
      return noticeOrderStatus == 'N' || noticeCostStatus !== 'N'
    },
  },
  {
    text: that.$l('menu_text_plan') || '生成计划',
    icon: 'el-icon-date',
    menuType: 'plan',
    allow: 'P',
    disabled: ({ noticeOrderStatus, noticePlanStatus }) => {
      return noticeOrderStatus == 'N' || noticePlanStatus !== 'N'
    },
  },
  {
    text: that.$l('btn_nc_status_rollback') || 'NC赋码状态回退',
    icon: 'el-icon-back',
    menuType: 'rollback',
    allow: 'R',
    disabled: ({ noticeOrderStatus}) => {
      return noticeOrderStatus == 'N' 
    },
  }
]
